<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-card-subtitle class="pt-4 pb-0">
        {{ question.question }}
      </v-card-subtitle>
      <v-card-title>
        Answered:
        <span class="accent--text ml-1">{{
          answer.answer || answer.value
        }}</span>
      </v-card-title>
      <v-card-text class="px-0 pb-0">
        <v-text-field
          v-model="search"
          outlined
          placeholder="Search by keyword"
          clearable
          class="px-4"
        >
        </v-text-field>
        <v-simple-table class="pb-4">
          <tbody>
            <tr v-for="(answer, i) in filtered_users" :key="i">
              <td>
                <user-chip :user="answer.user"></user-chip>
              </td>
              <td class="text-right">{{ answer.answerDate | normalDate }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyAnswerUsersDialog",
  components: {},
  props: {
    surveyId: { type: String }
  },
  data: () => ({
    dialog: false,
    loading: false,
    question: {},
    answer: {},
    search: ""
  }),
  computed: {
    filtered_users() {
      let users = this.answer_users;
      if (this.search) {
        let search = this.search.toLowerCase();
        users = users.filter(
          x => x.user.fullName.toLowerCase().indexOf(search) >= 0
        );
      }
      return users;
    },
    ...mapGetters({
      answer_users: "reporting/answer_users"
    })
  },
  created() {},
  methods: {
    showDialog(question, answer, filter) {
      this.question = question;
      this.answer = answer;
      this.dialog = true;
      this.loading = true;
      this.$store
        .dispatch("reporting/getSurveyAnswerUsers", {
          surveyId: this.surveyId,
          questionId: this.question.id,
          answerId: this.answer.id || this.answer.value,
          filter: filter
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading users."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
